<template>
  <GeneralLink
    text=""
    :link="clickable"
    _type="generalLink"
  >
    <PtcPicture
      v-if="image.asset"
      provider="sanity"
      :src="image.asset._ref"
      :alt="image.altText"
    />
  </GeneralLink>
</template>

<script lang="ts" setup>
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { ClickableImage } from '~/sanity/types';

defineProps<ClickableImage>();
</script>

<style></style>
